import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import DonorForm from "@/pages/DonorForm";
import Fiesta from "@/pages/Fiesta";
import SurveyRedirect from "@/pages/SurveyRedirect";
import SurveyPoster from "@/pages/SurveyPoster";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/donor-form" element={<DonorForm />} />
          <Route path="/fiesta" element={<Fiesta />} />
          <Route path="/survey-poster" element={<SurveyPoster />} />
          <Route path="/survey/*" element={<SurveyRedirect />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
